import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import StyleGuide from './pages/StyleGuide';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import CommunityDetailHomes from './pages/CommunityDetail/Homes';
import CommunityDetailPlans from './pages/CommunityDetail/FloorPlans';
import Homes from './pages/Homes';
import HomeDetail from './pages/HomeDetail';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import PlanLibrary from './pages/PlanLibrary';
import PlanLibraryDetail from './pages/PlanLibraryDetail';
import WarrantyRequestThankYou from './pages/WarrantyRequest/ThankYou';
import PageLoader from './components/PageLoader';
import SpecialOffers from './pages/SpecialOffers';
import SpecialOffersDetail from './pages/SpecialOffersDetail';


ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="RegionalSimple"
      components={[
        { override: 'NoRoute', component: PageLoader('error_404') },
        { override: 'Index', component: PageLoader('home_page') },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunityDetailHomes', component: CommunityDetailHomes },
        { override: 'CommunityDetailPlans', component: CommunityDetailPlans },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes, filtersRemove: ['OpenHouse', 'Model'] },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: Plans },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'BlogpostList', component: PageLoader('blog') },
        { override: 'BlogpostDetail', component: PageLoader('blog_detail') },
      ]}
      routes={[
        { name: 'style-guide', exact: true, path: '/style-guide', component: StyleGuide },
        { name: 'accessibility', exact: true, path: '/accessibility', component: PageLoader('accessibility') },
        { name: 'available-lots', exact: true, path: '/available-lots', component: PageLoader('available_lots') },
        { name: 'awards-and-affiliations', exact: true, path: '/awards-and-affiliations', component: PageLoader('awards_affiliations') },
        { name: 'contact-us', exact: true, path: '/contact-us', component: PageLoader('contact_us') },
        { name: 'customer-care', exact: true, path: '/customer-care', component: PageLoader('customer_care') },
        { name: 'customizing-your-home', exact: true, path: '/customizing-your-home', component: PageLoader('customizing_your_home') },
        { name: 'faq', exact: true, path: '/faq', component: PageLoader('frequently_asked_questions') },
        { name: 'financing-info', exact: true, path: '/financing-info', component: PageLoader('financing_info') },
        { name: 'home-page-options', exact: true, path: '/home-page-options', component: PageLoader('home_page_options') },
        { name: 'homeowner-tips', exact: true, path: '/homeowner-tips', component: PageLoader('homeowner_tips') },
        { name: 'meet-the-team', exact: true, path: '/meet-the-team', component: PageLoader('meet_the_team') },
        { name: 'photo-gallery', exact: true, path: '/photo-gallery', component: PageLoader('photo_gallery') },
        { name: 'photo-gallery', exact: true, path: '/photo-gallery/:photo_gallery', component: PageLoader('photo_gallery'), sitemapIgnore: true },
        { name: 'plan-library', exact: true, path: '/plan-library', component: PlanLibrary, filtersRetain: ['Beds', 'Baths', 'Sqft'] },
        { name: 'plan-library-detail', exact: true, path: '/plan-library/:planName', component: PlanLibraryDetail },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: PageLoader('privacy_policy') },
        { name: 'terms', exact: true, path: '/terms', component: PageLoader('terms') },
        { name: 'testimonials', exact: true, path: '/testimonials', component: PageLoader('testimonials') },
        { name: 'video-gallery', exact: true, path: '/video-gallery', component: PageLoader('video_gallery') },
        { name: 'video-gallery-filtered', exact: true, path: '/video-gallery/:gallery', component: PageLoader('video_gallery'), sitemapIgnore: true },
        { name: 'warranty-info', exact: true, path: '/warranty-info', component: PageLoader('warranty_info') },
        { name: 'warranty-request', exact: true, path: '/warranty-request', component: PageLoader('warranty_request') },
        { name: 'warranty-request-thank-you', exact: true, path: '/warranty-request/thank-you', component: WarrantyRequestThankYou, sitemapIgnore: true },
        { name: 'why-first-choice', exact: true, path: '/why-first-choice', component: PageLoader('why_first_choice') },
        { name: 'special-offers', exact: true, path: '/special-offers', component: SpecialOffers },
        { name: 'special-offers-detail', exact: true, path: '/special-offers/:title', component: SpecialOffersDetail },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js